import { ReactNode } from 'react';

import { actionUrl } from 'config/static-content';
import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';

type ContactLinkProps = {
  children: ReactNode;
  queryString?: string;
};

export const ContactLink = ({ children, queryString = '' }: ContactLinkProps) => (
  <NsAnchor href={`${actionUrl.contact}?${queryString}`}>{children}</NsAnchor>
);
